import React from "react";
import { Link, useLocation } from "react-router-dom";

function DashboardSidebar() {
  const location = useLocation();

  function isCurrent(path) {
      if (!path.startsWith("/")) path = "/" + path;
    path = "/dashboard" + path;
    if (path === "/dashboard/") return location.pathname+"/" === path;
    return location.pathname.startsWith(path);
  }
    return (
      <>
        <div className="btn2 header-item " id="left-menu-btn">
          <span className="hamburger-icon">
            <span />
            <span />
            <span />
          </span>
        </div>
        {/* ========== Left Sidebar ========== */}
        <div className="left-menu">
          {/*- Sidemenu */}
          <div id="sidebar-menu">
            {/* Logo Box */}
            <div className="logo-box d-flex">
              <div className="logo">
                <a href="/">
                  <img
                    src="/assets/images/logo/logo3%402x.png"
                    alt=""
                    width={197}
                    height={48}
                    className="img-logo"
                  />
                  <img
                    src="/assets/images/logo/toggle-logo%402x.png"
                    alt=""
                    width={46}
                    height={48}
                    className="toggle-logo"
                  />
                </a>
              </div>
            </div>
            <div className="profile-box">
              <div className="title-1 fw-6">Compte</div>
              <div className="avatar-box flex align-center">
                <div className="avatar flex-none">
                  <img src="/assets/images/author/avatar.png" alt="" title="" />
                </div>
                <div className="content">
                  <div className="sub-title fs-12 lh-18">Max Dev</div>
                  <div className="titles fw-6">
                    <a href="#">test@gmail.com</a>{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="title-2 fw-6">Menu</div>
            <ul className="downmenu list-unstyled" id="side-menu">
              <li>
                <Link
                  to="/dashboard"
                  className={"tf-effect " + (isCurrent("/") && "active")}
                >
                  <span className="icon-dash dash-icon">
                    <svg
                      width={22}
                      height={22}
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g>
                        <path
                          d="M6.75682 9.35156V15.64"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.0342 6.34253V15.64"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.2412 12.6746V15.64"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M15.2939 1.83331H6.70346C3.70902 1.83331 1.83203 3.95272 1.83203 6.95304V15.0469C1.83203 18.0472 3.70029 20.1666 6.70346 20.1666H15.2939C18.2971 20.1666 20.1654 18.0472 20.1654 15.0469V6.95304C20.1654 3.95272 18.2971 1.83331 15.2939 1.83331Z"
                          stroke="#F1FAEE"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </svg>
                  </span>
                  <span className="dash-titles">Tableau de bord</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard/profile"
                  className={
                    "has-arrow tf-effect " + (isCurrent("/profile") && "active")
                  }
                >
                  <span className="icon-dash dash-icon">
                    <svg
                      width={22}
                      height={22}
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.987 14.0674C7.44168 14.0674 4.41406 14.6034 4.41406 16.7502C4.41406 18.8969 7.42247 19.4521 10.987 19.4521C14.5323 19.4521 17.5591 18.9152 17.5591 16.7694C17.5591 14.6235 14.5515 14.0674 10.987 14.0674Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.9866 11.0054C13.3132 11.0054 15.1989 9.11885 15.1989 6.79226C15.1989 4.46567 13.3132 2.57996 10.9866 2.57996C8.66005 2.57996 6.77346 4.46567 6.77346 6.79226C6.7656 9.11099 8.6391 10.9976 10.957 11.0054H10.9866Z"
                        stroke="white"
                        strokeWidth="1.42857"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="dash-titles">Profile</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard/review"
                  className={"tf-effect " + (isCurrent("/review") && "active")}
                >
                  <span className="icon-work dash-icon">
                    <svg
                      width={22}
                      height={22}
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.4076 8.11353L12.3346 11.4255C11.5651 12.036 10.4824 12.036 9.71285 11.4255L5.60547 8.11353"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.4985 19.25C18.2864 19.2577 20.1654 16.9671 20.1654 14.1518V7.85584C20.1654 5.04059 18.2864 2.75 15.4985 2.75H6.49891C3.711 2.75 1.83203 5.04059 1.83203 7.85584V14.1518C1.83203 16.9671 3.711 19.2577 6.49891 19.25H15.4985Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="dash-titles">Avis clients</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard/properties"
                  className={"tf-effect " + (isCurrent("properties") && "active")}
                >
                  <span className="icon-applicant dash-icon">
                    <svg
                      width={22}
                      height={22}
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.533 2.55658H7.10561C4.28686 2.55658 2.51953 4.55216 2.51953 7.37733V14.9985C2.51953 17.8237 4.27861 19.8192 7.10561 19.8192H15.1943C18.0222 19.8192 19.7813 17.8237 19.7813 14.9985V11.3062"
                        stroke="#F1FAEE"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.09012 10.0108L14.9404 3.16055C15.7938 2.30805 17.177 2.30805 18.0305 3.16055L19.146 4.27614C19.9995 5.12955 19.9995 6.51372 19.146 7.36622L12.2628 14.2495C11.8897 14.6226 11.3837 14.8325 10.8557 14.8325H7.42188L7.50804 11.3675C7.52087 10.8578 7.72896 10.372 8.09012 10.0108Z"
                        stroke="#F1FAEE"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.8984 4.21893L18.0839 8.40443"
                        stroke="#F1FAEE"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="dash-titles">Biens immobiliers</span>
                </Link>
              </li>
             <li style={{ position:"absolute", bottom:0 }}>
                <a href="/" className="tf-effect">
                  <span className="icon-log-out dash-icon">
                    <svg
                      width={22}
                      height={22}
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.7627 6.77369V5.91844C13.7627 4.05303 12.2502 2.54053 10.3848 2.54053H5.91606C4.05156 2.54053 2.53906 4.05303 2.53906 5.91844V16.1209C2.53906 17.9864 4.05156 19.4989 5.91606 19.4989H10.394C12.2539 19.4989 13.7627 17.9909 13.7627 16.131V15.2666"
                        stroke="#F1FAEE"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M19.9907 11.0196H8.95312"
                        stroke="#F1FAEE"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M17.3047 8.34741L19.9887 11.0195L17.3047 13.6925"
                        stroke="#F1FAEE"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="dash-titles">Déconnexion</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* left sidebar end */}
      </>
    );
}

export default DashboardSidebar;
